
import Vue from "vue"
import Contact from './index.vue'
import Prewview from '@/components/preview/index.vue'
export default Vue.extend({
   components:{
	Contact,
	Prewview
   }
})
